const utils = {};

utils.addListenerToAll = function addListenerToAll(eventType, selector, callbackFunction, options) {
  if (!eventType || !selector || !callbackFunction) {
    return;
  }
  
  let elements = Array.from(document.querySelectorAll(selector));
  elements.forEach((element) => {
    element.addEventListener(eventType, callbackFunction, options);
  });
}

utils.toggleClassForAll = function toggleClassForAll(selector, toggleClassName, state) {
  if (!selector || !toggleClassName) {
    return;
  }
  
  let elements = Array.from(document.querySelectorAll(selector));
  elements.forEach((element) => {
    element.classList?.toggle(toggleClassName, state);
  });
}

utils.addListenersToAll = function addListenersToAll (eventTypes, selector, callbackFunction, options) {
  if (!eventTypes || !Array.isArray(eventTypes) || !selector || !callbackFunction) {
    return;
  }
  eventTypes.forEach((event) => {
    utils.addListenerToAll(event, selector, callbackFunction, options);
  });
}

utils.setInnerHtml = function setInnerHtml (selector, innerHtml) {
  if (document.querySelector(selector)) {
    document.querySelector(selector).innerHTML = innerHtml;
  }
}

utils.removeAllElements = function removeAllElements (selector) {
  let elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    element.remove();
  });
}

utils.showAllElements = function showAllElements (selector) {
  let elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    element.style.display = 'block';
  });
}

utils.hideAllElements = function hideAllElements (selector) {
  let elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    element.style.display = 'none';
  });
}

utils.emptyElement = function emptyElement (selector) {
  let element = document.querySelector(selector);
  while (element?.firstChild) {
    element.removeChild(element.firstChild);
  }
}

utils.delegateListeners = function delegateListeners (eventTypes, selector, handler) {
  eventTypes.forEach((eventType) => {
    document.addEventListener(eventType, function(event) {
      // loop parent nodes from the target to the delegation node
      for (let target = event.target; target && target != this; target = target.parentNode) {
        if (target.matches(selector)) {
          handler.call(target, event);
          break;
        }
      }
    }, true);
  })
}

// Pass in the objects to merge as arguments.
// For a deep extend, set the first argument to `true`.
// let newObjectDeep = extend(true, object1, object2, object3)
utils.extendObject = function extendObject() {
  // Variables
  let extended = {}
  let deep = false
  let i = 0
  let length = arguments.length

  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0]
    i++
  }

  // Merge the object into the extended object
  const merge = obj => {
    for (let prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (
          deep &&
          Object.prototype.toString.call(obj[prop]) === '[object Object]'
        ) {
          extended[prop] = utils.extendObject(true, extended[prop], obj[prop])
        } else {
          extended[prop] = obj[prop]
        }
      }
    }
  }

  // Loop through each object and conduct a merge
  for (; i < length; i++) {
    let obj = arguments[i]
    merge(obj)
  }

  return extended
}

utils.deferred = function deferred() {
  let resolve;
  let reject;

  const _promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  return {
    resolve: resolve,
    reject: reject,
    promise: function promise() { return _promise; }
  };
}

utils.fetchWithTimeout = function fetchWithTimeout(resource, options = {}) {
  const {timeout = 5000} = options;
  const aborter = new AbortController();
  const ticker = setTimeout(() => aborter.abort(), timeout);

  return fetch(resource, {
    ...options,
    signal: aborter.signal
  }).then((res)=>{
    clearTimeout(ticker);
    return res;
  });
}

export default utils